import { render, staticRenderFns } from "./LoginPromptDialog.vue?vue&type=template&id=208f1033&scoped=true&"
import script from "./LoginPromptDialog.vue?vue&type=script&lang=ts&"
export * from "./LoginPromptDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPromptDialog.vue?vue&type=style&index=0&id=208f1033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f1033",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
